import { Container } from "semantic-ui-react";


export function numberToCharTG(num) {
    var s = '';
    var myArr = String(Number(num) + 10000).split("").map((num) => {
        return Number(num)
    })
    for (let i = 0; i < myArr.length; i++) {
        if (myArr[i] === 0) {//z
            s = s + String.fromCharCode(26 + 96);
        } else {
            s = s + String.fromCharCode(myArr[i] + 96);
        }

    }

    return s || undefined;
}

export function changeInitialScale(ile, scalable = 0) {

    if (ile === 1 && scalable === 0) {
        document.querySelector("meta[name=viewport]").setAttribute(
            'content',
            'width=device-width, initial-scale=' + ile + ', user-scalable=0, minimum-scale=1, maximum-scale=1');
    } else if (ile === 1 && scalable === 1) {

        document.querySelector("meta[name=viewport]").setAttribute(
            'content',
            'width=device-width, initial-scale=' + ile + ', user-scalable=1, minimum-scale=0.5, maximum-scale=2');

    } else {
        document.querySelector("meta[name=viewport]").setAttribute(
            'content',
            'width=device-width, initial-scale=' + ile + ', user-scalable=1, minimum-scale=0.1, maximum-scale=2');
    }

}

export function loadingShowLogo(isDark) {
    return <Container textAlign='center' style={{ paddingTop: 20 }}>
        <img className="loaderTG3IMGWT" src="https://tg-app.pl/img/logo/logotgsmall10.png" alt="Logo ładowania" />
        <div className={isDark ? "pre-loaderTGTXTDark" : "pre-loaderTGTXT"}>Trwa pobieranie danych<br />
            <span className="pre-loaderTGTXTTG">Proszę czekać...</span></div>
    </Container>
}

export function changeFormatLongDateWithOptionalTime(mydate, inline = false) {
    try {
        if (!mydate) return "";
        const d = new Date(mydate);
        if (isNaN(d)) return mydate;

        const lang = 'pl';

        const dateStr = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long', year: 'numeric' }).format(d);

        const hours = d.getHours();
        const minutes = d.getMinutes();

        const timeStr = (hours === 0 && minutes === 0) || (hours === 23 && minutes === 59) ? "" : `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

        if (timeStr) {
            if (inline) {
                return <>
                    <span>{dateStr}, {timeStr}</span>
                    
                </>
            }
            return <>
                <div>{dateStr}</div>
                <div style={{ fontSize: 13, marginTop: 2 }}>{timeStr}</div>
            </>
        } else {
            return dateStr;
        }

    } catch (error) {
        if (Number(process.env.REACT_APP_API_DEBUG) === 1) console.log(error)
        return mydate
    }

}